<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form">
      <a-form-model-item label="申领编号（可复制给开发用）" prop="applyId">
        <a-input v-model="form.applyId" disabled />
      </a-form-model-item>
      <a-form-model-item label="店铺名称" prop="shopName" >
        <a-input v-model="form.shopName" disabled />
      </a-form-model-item>
      <a-form-model-item label="剧本名称" prop="scriptName" >
        <a-input v-model="form.scriptName" disabled />
      </a-form-model-item>
      <a-form-model-item label="类别" prop="type" >
        <a-select v-model="form.type" placeholder="请选择类别" disabled>
          <a-select-option :value="1">免费申领</a-select-option>
          <a-select-option :value="2">预购/再领一本	</a-select-option>
        </a-select>
      </a-form-model-item>
      <!--      <a-form-model-item label="订单id" prop="orderId" >-->
      <!--        <a-input v-model="form.orderId" placeholder="请输入订单id" />-->
      <!--      </a-form-model-item>-->
      <a-form-model-item label="下单价格" prop="orderPrices" v-if="form.type === 2">
        <a-input v-model="form.orderPrices" disabled />
      </a-form-model-item>
      <a-form-model-item label="预购车数量" prop="preOrderCarNum" v-if="form.type === 2" >
        <a-input v-model="form.preOrderCarNum" disabled />
      </a-form-model-item>
      <a-card hoverable title="收货信息" style="margin-bottom: 10px;" v-if="form.addressVO">
        <a-form-model-item label="收货人" prop="addressee" >
          <a-input v-model="form.addressVO.addressee" disabled />
        </a-form-model-item>
        <a-form-model-item label="收货手机号" prop="mobile" >
          <a-input v-model="form.addressVO.mobile" disabled />
        </a-form-model-item>
        <a-form-model-item label="详细地址" prop="shippingAddress" >
          <a-textarea v-model="form.addressVO.shippingAddress" :rows="2" disabled />
        </a-form-model-item>
        <a-form-model-item label="是否顺丰到付" prop="isSfCod" >
          <a-input :value="form.isSfCod ? '是':'否'" disabled />
        </a-form-model-item>
        <a-form-model-item label="发货备注" prop="remarkNoteTwo" >
          <a-textarea v-model="form.remarkNoteTwo" disabled />
        </a-form-model-item>
      </a-card>
      <a-card hoverable title="申领任务" style="margin-bottom: 10px;" v-if="form.applyMissionList && form.applyMissionList.length > 0">
        <div v-for="(item, index) in form.applyMissionList" :key="index">
          <a-form-model-item :label="item.title" prop="title" >
            <a-input v-model="item.desc" disabled />
            <oss-multi-upload
              v-if="item.resultImg && item.resultImg.length > 0"
              v-model="item.resultImg"
              :max-count="0"
              type="img"
              :isMultiple="true"
              :isRemove="false"
            />
            <a-textarea v-model="item.content" :rows="4" disabled v-if="item.content" />
          </a-form-model-item>
        </div>
      </a-card>
      <a-form-model-item label="申领备注" prop="remarkNoteOne" v-if="form.applyMissionList && form.applyMissionList.length > 0">
        <a-textarea v-model="form.remarkNoteOne" disabled />
      </a-form-model-item>
      <a-card hoverable title="申领任务" v-if="form.shippingMissionList && form.shippingMissionList.length > 0">
        <div v-for="(item, index) in form.shippingMissionList" :key="index">
          <a-form-model-item :label="item.title" prop="title" >
            <a-input v-model="item.desc" disabled />
            <oss-multi-upload
              v-if="item.resultImg && item.resultImg.length > 0"
              v-model="item.resultImg"
              :max-count="0"
              type="img"
              :isMultiple="true"
              :isRemove="false"
            />
            <a-textarea v-model="item.content" :rows="4" disabled v-if="item.content" />
          </a-form-model-item>
        </div>
      </a-card>
      <!--      <a-form-model-item label="收货快照地址id" prop="shippingAddressSnapshotId" >-->
      <!--        <a-input v-model="form.shippingAddressSnapshotId" placeholder="请输入收货快照地址id" />-->
      <!--      </a-form-model-item>-->
      <a-form-model-item label="快递公司" prop="shippingCompany" v-if="form.status === 21 || form.status === 40 || form.status === 99" >
        <a-input v-model="form.shippingCompany" disabled />
      </a-form-model-item>
      <a-form-model-item label="快递编号" prop="shippingNumber" v-if="form.status === 21 || form.status === 40 || form.status === 99" >
        <a-input v-model="form.shippingNumber" disabled />
      </a-form-model-item>
      <a-form-model-item label="发货时间" prop="shippingTime" v-if="form.status === 21 || form.status === 40 || form.status === 99" >
        <a-date-picker style="width: 100%" v-model="form.shippingTime" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" disabled />
      </a-form-model-item>
      <a-form-model-item label="预计发货任务日期" prop="expectedShippingMissionDate" v-if="form.status === 21" >
        <a-date-picker style="width: 100%" v-model="form.expectedShippingMissionDate" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" disabled />
      </a-form-model-item>
      <a-form-model-item label="激活时间" prop="activateTime" v-if="form.status === 40 || form.status === 99" >
        <a-date-picker style="width: 100%" v-model="form.activateTime" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" disabled />
      </a-form-model-item>
      <a-form-model-item label="是否三方平台" prop="isThirty" v-if="form.isThirty === 1">
        <a-select v-model="form.isThirty" disabled>
          <a-select-option :value="1">是</a-select-option>
          <a-select-option :value="0">否</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="配送状态" prop="shippingStatus" >
        <a-select v-model="form.shippingStatus" disabled>
          <a-select-option :value="1">待发货</a-select-option>
          <a-select-option :value="2">运输中</a-select-option>
          <a-select-option :value="3">派件中</a-select-option>
          <a-select-option :value="4">已签收</a-select-option>
          <a-select-option :value="5">未知</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="状态" prop="status" >
        <a-select style="width: 100%" v-model="form.status" disabled>
          <a-select-option v-for="(item, index) in this.customDict.PlayedScriptApplyStatusEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item
        label="提交时间"
        prop="submitTime"
        v-if="form.status === 10 || form.status === 20 || form.status === 11 || form.status === 21 || form.status === 40"
      >
        <a-date-picker style="width: 100%" v-model="form.submitTime" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" disabled />
      </a-form-model-item>
      <!--      <a-form-model-item label="支付取消时间" prop="payCancelTime" >-->
      <!--        <a-date-picker style="width: 100%" v-model="form.payCancelTime" format="YYYY-MM-DD HH:mm:ss" disabled />-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="逻辑删除标记 1:删除,0:未删除" prop="isDeleted" >-->
      <!--        <a-input v-model="form.isDeleted" placeholder="请输入逻辑删除标记 1:删除,0:未删除" />-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="备注" prop="remark" >-->
      <!--        <a-input v-model="form.remark" placeholder="请输入备注" />-->
      <!--      </a-form-model-item>-->
      <a-modal
        v-model="auditVisible"
        :loading="auditLoading"
        title="审核任务"
        @ok="handleOk(4)"
        :closable="true"
        :get-container="false"
      >
        <template slot="footer">
          <a-button type="primary" :loading="auditLoading" @click="handleOk(1)">
            审核通过
          </a-button>
          <a-button type="primary" :loading="auditLoading" @click="handleOk(2)">
            审核驳回
          </a-button>
          <a-button @click="auditVisible = false">取消</a-button>
        </template>
        <a-textarea v-model="reason" placeholder="审核驳回请说明原因" :max-length="200" allow-clear/>
      </a-modal>

      <a-modal
        v-model="shipmentVisible"
        :loading="shipmentLoading"
        title="剧本发货"
        @ok="handleOk(4)"
        :closable="true"
      >
        <a-form-model-item label="快递公司" prop="shippingCompany" >
          <a-select placeholder="请选择快递公司" v-model="shippingCompany" style="width: 100%" allow-clear>
            <a-select-option v-for="(d, index) in dict.type['courier_services_company']" :key="index" :value="d.value">
              {{ d.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="快递编号" prop="shippingNumber" >
          <a-input v-model="shippingNumber" placeholder="请输入快递编号" :maxLength="32"/>
        </a-form-model-item>
        <template slot="footer">
          <a-button type="primary" :loading="auditLoading" @click="shipment()">
            提交发货信息
          </a-button>
          <a-button @click="shipmentVisible = false">取消</a-button>
        </template>
      </a-modal>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="auditLoading" @click="auditVisible = true" v-if="form.status === 10 || form.status === 20">
            审核
          </a-button>
          <a-button type="primary" :loading="shipmentLoading" @click="shipmentVisible = true" v-if="form.status === 21 && !form.shippingStatus">
            剧本发货
          </a-button>
          <!--          <a-button type="primary" :loading="submitLoading" @click="submitForm">-->
          <!--            保存-->
          <!--          </a-button>-->
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {
  getScriptApply,
  addScriptApply,
  updateScriptApply,
  auditApplyStatus,
  confirmShipment
} from '@/api/played/scriptApply'
import { mapGetters } from 'vuex'
import OssMultiUpload from '@/views/script/script/modules/OssMultiUpload.vue'

export default {
  name: 'CreateForm',
  dicts: ['courier_services_company'],
  props: {
  },
  components: {
    OssMultiUpload
  },
  data () {
    return {
      auditVisible: false,
      shipmentVisible: false,
      submitLoading: false,
      auditLoading: false,
      shipmentLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        applyId: null,
        shopId: null,
        scriptId: null,
        orderId: null,
        type: null,
        orderPrices: null,
        preOrderCarNum: null,
        shippingAddressSnapshotId: null,
        shippingNumber: null,
        shippingCompany: null,
        shippingTime: null,
        addressVO: null,
        applyMissionList: [],
        shippingMissionList: [],
        expectedShippingMissionDate: null,
        activateTime: null,
        isThirty: null,
        shippingStatus: 0,
        status: 0,
        createTime: null,
        creator: null,
        updateTime: null,
        submitTime: null,
        payCancelTime: null,
        modifier: null,
        isDeleted: null,
        isSfCod: null,
        remarkNoteOne: null,
        remarkNoteTwo: null
      },
      reason: null,
      shippingNumber: '',
      shippingCompany: undefined,
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        shopId: [
          { required: true, message: '店铺id不能为空', trigger: 'blur' }
        ],
        scriptId: [
          { required: true, message: '剧本id不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '类别 1.免费申领 2.预购不能为空', trigger: 'change' }
        ],
        orderPrices: [
          { required: true, message: '预购价格不能为空', trigger: 'blur' }
        ],
        preOrderCarNum: [
          { required: true, message: '预购车数量不能为空', trigger: 'blur' }
        ],
        isThirty: [
          { required: true, message: '是否三方 1.是 0.否不能为空', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '状态 详见PlayedScriptApplyStatusEnum不能为空', trigger: 'blur' }
        ],
        isDeleted: [
          { required: true, message: '逻辑删除标记 1:删除,0:未删除不能为空', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '备注不能为空', trigger: 'blur' }
        ],
        version: [
          { required: true, message: '版本号不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        shopId: null,
        scriptId: null,
        orderId: null,
        type: null,
        orderPrices: null,
        preOrderCarNum: null,
        shippingAddressSnapshotId: null,
        shippingNumber: null,
        shippingCompany: null,
        shippingTime: null,
        expectedShippingMissionDate: null,
        activateTime: null,
        isThirty: null,
        shippingStatus: 0,
        status: 0,
        createTime: null,
        creator: null,
        updateTime: null,
        submitTime: null,
        payCancelTime: null,
        modifier: null,
        isDeleted: null,
        remark: null,
        version: null,
        isSfCod: null,
        remarkNoteOne: null,
        remarkNoteTwo: null
      }
      this.reason = null
      this.shippingNumber = ''
      this.shippingCompany = undefined
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getScriptApply(id).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateScriptApply(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addScriptApply(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    handleOk (status) {
      const data = {
        'id': this.form.applyId,
        'auditStatus': status,
        'rejectReason': this.reason
      }
      auditApplyStatus(data).then(response => {
        this.$message.success(
          '审核成功',
          3
        )
        this.auditVisible = false
        this.open = false
        this.$emit('ok')
      }).catch(err => {
        this.$message.error(
          '审核失败!' + err.message,
          5
        )
      }).finally(() => {
        this.auditLoading = false
      })
    },
    shipment() {
      if (!this.shippingCompany) {
        this.$message.warning('请输入快递公司')
        return
      }
      if (!this.shippingNumber || this.shippingNumber.length < 8) {
        this.$message.warning('请输入正确的快递编号')
        return
      }
      const data = {
        'id': this.form.applyId,
        'shippingNumber': this.shippingNumber,
        'shippingCompany': this.shippingCompany
      }
      confirmShipment(data).then(response => {
        this.$message.success(
          '提交发货信息成功',
          3
        )
        this.shipmentVisible = false
        this.open = false
        this.$emit('ok')
      }).catch(err => {
        this.$message.error(
          '提交失败:' + err.message,
          5
        )
      }).finally(() => {
        this.shipmentLoading = false
      })
    }
  }
}
</script>
